import { render, staticRenderFns } from "./TepContratoInternoIndex.vue?vue&type=template&id=0b0ab57a"
import script from "./TepContratoInternoIndex.vue?vue&type=script&lang=js"
export * from "./TepContratoInternoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports